import React, { useCallback, useEffect, useRef, useState } from "react";
import style from "css/zwcad.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import ZwcadFeatureListItem from "components/zwcad/zwcadFeatureListItem";
import Underbar from "components/common/underbar";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import Mobilemenu from "components/common/mobilemenu";
/**
 * Version : 1.0
 * 작성일자 : 2024-02-14
 * 작성자 : 강연승
 * 설명 : ZWCAD 페이지
 */

function Security() {
  //navigate
  const navigate = useNavigate();
  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const menuHandler = (e) => {
    navigate(process.env.REACT_APP_CLIENT_URL + e);
  };

  const location = useLocation();
  const content0Ref = useRef(null);
  const content1Ref = useRef(null);
  const content2Ref = useRef(null);
  const content3Ref = useRef(null);
  const content4Ref = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (location.state === null) {
        content0Ref.current?.scrollIntoView({ behavior: "smooth" });
      } else {
        switch (location.state.title) {
          case 1:
            content0Ref.current?.scrollIntoView({ behavior: "smooth" });
            break;
          case 2:
            content2Ref.current?.scrollIntoView({ behavior: "smooth" });
            break;
          case 3:
            content3Ref.current?.scrollIntoView({ behavior: "smooth" });
            break;
          case 4:
            content4Ref.current?.scrollIntoView({ behavior: "smooth" });
            break;
          default:
            break;
        }
      }
    }, 250); // 0.1초 딜레이

    // 컴포넌트가 언마운트될 때 타이머 정리
    return () => clearTimeout(timer);
  }, [location, isMobile]);
  return (
    <>
      <div className={style.wrapper}>
        <div
          className={style.background}
          ref={content0Ref}
          style={
            isMobile
              ? {
                  backgroundImage:
                    "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/product/security/securitymh.png')",
                }
              : {
                  backgroundImage:
                    "url('" +
                    process.env.REACT_APP_CLIENT_URL +
                    "img/product/security/securityh.png')",
                }
          }
        ></div>
        <div className={style.zwcad_area}>
          <div className={style.zwcad_title_wrap}>
            <div className={style.zwcad_title}>
              <div className={style.zwcad_title2}>AhnLab V3 제품군</div>
              <div>세계 최고 수준의 {isMobile ? <p /> : ""} 안티멀웨어</div>
            </div>
            <div className={style.zwcad_subtitle}>
              <div>
                안랩 V3 제품군은 전 세계적으로 {isMobile ? <p /> : ""} 검증된
                기술력과 30년간 축적된
              </div>
              <div>
                안랩의 노하우를 바탕으로 글로벌 최고 수준의{" "}
                {isMobile ? <p /> : ""}안티멀웨어 역량을 제공합니다.
              </div>
            </div>
          </div>
        </div>
      </div>
      {isMobile ? (
        <div className="product_mobile_wrapper">
          <div className="product_mobile_body">
            <div className="product_mobile_contents" ref={content1Ref}>
              <img
                alt="security1"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/security/securitym1.png"
                }
              />
            </div>
            <div className="product_mobile_contents" ref={content2Ref}>
              <img
                alt="security2"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/security/securitym2.png"
                }
              />
            </div>
            <div className="product_mobile_contents">
              <img
                alt="security3"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/security/securitym3.png"
                }
              />
            </div>
            <div className="product_mobile_contents" ref={content3Ref}>
              <img
                alt="security4"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/security/securitym4.png"
                }
              />
            </div>
            <div className="product_mobile_contents">
              <img
                alt="security5"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/security/securitym5.png"
                }
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="product_wrapper" ref={content1Ref}>
          <div className="product_body">
            <div className="product_contents">
              <img
                alt="zwcad1"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/security/security1.png"
                }
              />
            </div>
            <div className="product_contents" ref={content2Ref}>
              <img
                alt="zwcad2"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/security/security2.png"
                }
              />
            </div>
            <div className="product_contents" ref={content3Ref}>
              <img
                alt="zwcad3"
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/product/security/security3.png"
                }
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Security;
